import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { hqTab, retailTab } from './constants';
import { DepartmentTabs } from './DepartmentTabs';
import { DepartmentList } from './DepartmentList';
import { DepartmentFilters } from './DepartmentFilters';
import { Department, Departments, Job } from './index.types';

const transformData = (departments: Department[]) =>
  departments.reduce(
    (acc: Record<string, Departments>, department: Department) => {
      if (department.jobs.length > 0) {
        const trimmedName = department.name.trim();
        const tab = trimmedName === 'Stores' ? retailTab : hqTab;
        const tabDepartments = acc[tab] || {};
        tabDepartments[trimmedName] = [...(tabDepartments[trimmedName] || []), ...department.jobs];
      }
      return acc;
    },
    { [hqTab]: {}, [retailTab]: {} }
  );

const filterDepartments = (departmentEntries: [string, Job[]][], departmentFilter: string, locationFilter: string) =>
  departmentEntries.reduce((acc: Departments, [department, jobs]) => {
    if (!departmentFilter || departmentFilter === department) {
      const departmentJobs = locationFilter
        ? jobs.filter(({ location }: Job) => locationFilter === location.name)
        : jobs;
      if (departmentJobs.length > 0) acc[department] = departmentJobs;
    }
    return acc;
  }, {});

type Props = {
  activeTab: string;
  setActiveTab: (tab: string) => void;
};

export const CareerListings = ({ activeTab, setActiveTab }: Props) => {
  const [loading, setLoading] = useState(false);
  const [departments, setDepartments] = useState<Record<string, Departments>>({});
  const [departmentFilter, setDepartmentFilter] = useState('');
  const [locationFilter, setLocationFilter] = useState('');

  useEffect(() => {
    setLoading(true);
    fetch(`https://boards-api.greenhouse.io/v1/boards/aloyoga/departments`)
      .then((response) => response.json())
      .then(({ departments }) => {
        setDepartments(transformData(departments));
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log({ error });
      });
  }, []);

  const onTabClick = (tab: string) => {
    setLocationFilter('');
    setDepartmentFilter('');
    setActiveTab(tab);
  };

  const tabDepartments = departments[activeTab] || {};
  const departmentEntries = Object.entries(tabDepartments);
  const activeDepartments = filterDepartments(departmentEntries, departmentFilter, locationFilter);

  return (
    <Grid id="job-listings" container className="career-listings">
      {departmentEntries.length > 0 ? (
        <Grid item sm={12} md={8} className="departments">
          <h3 className="h3 uppercase center">Job Listings</h3>
          <DepartmentTabs onClick={onTabClick} activeTab={activeTab} />
          <DepartmentFilters
            departments={tabDepartments}
            listingCount={Object.values(activeDepartments).flat().length}
            setDepartmentFilter={setDepartmentFilter}
            setLocationFilter={setLocationFilter}
          />
          <DepartmentList departments={activeDepartments} />
        </Grid>
      ) : (
        <div className="no-jobs-message">
          {loading ? <p className="caption">Loading...</p> : <h4>Currently we don't have any job openings</h4>}
        </div>
      )}
    </Grid>
  );
};
